import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import PublicVisibilityFilterToggles from '@/components/buttons/PublicVisibilityFilterToggles';
import Filter from '@/components/Filter';
import { fetchDatasets, updateDatasetsFilter, updateDatasetsFlags } from '../actions';

const DatasetsFilters = ({
  category,
  className,
  commonsMode,
  fetchData,
  filterTerm,
  fluid,
  internalFlag,
  isGuest,
  privateFlag,
  publicFlag,
  readErrors,
  updateFilterTerm,
  updateFlags,
}) => (
  <Filter
    fluid={fluid}
    className={clsx('aridhia-datasets-filter', className)}
    filterTerm={filterTerm}
    updateFilter={({ value }) => updateFilterTerm(category, value)}
    error={firstErrorMessage(readErrors)}
    onFilter={() => fetchData(category, 1, null, false)}
    {...!isGuest && {
      label: <PublicVisibilityFilterToggles
        commonsMode={commonsMode}
        entity="datasets"
        privateFlag={privateFlag}
        internalFlag={internalFlag}
        publicFlag={publicFlag}
        updateFlags={(flags) => updateFlags(category, flags)}
      />,
    }}
  />
);

const mapStateToProps = ({
  auth: { commonsMode, currentUser },
  datasets: { datasets },
}, { category }) => {
  const {
    filter, privateFlag, internalFlag, publicFlag, readErrors,
  } = datasets[category];

  return ({
    commonsMode,
    filterTerm: filter,
    privateFlag,
    internalFlag,
    isGuest: currentUser ? currentUser.isGuest : true,
    publicFlag,
    readErrors,
  });
};

const mapDispatchToProps = {
  updateFlags: updateDatasetsFlags,
  updateFilterTerm: updateDatasetsFilter,
  fetchData: fetchDatasets,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetsFilters);
